<template>
  <div>
    <Nuxt />
  </div>
</template>

<style>
</style>
